const QUERIES = {
  FRANCHISE_LIST: 'franchise-list',
  PRODUCT_SHOW: 'product-show',
  PRODUCT_LIST: 'product-list',
  MACHINE_LIST: 'machine-list',
  MACHINE_SHOW: 'machine-show',
  CATEGORY_LIST: 'category-list',
  CATEGORY_SHOW: 'category-show',
  CIELO_MERCHANT_LIST: 'cielo-merchant-list',
  CIELO_MERCHANT_SHOW: 'cielo-merchant-show',
  CONTRACT_TERM_LIST: 'contract-term-list',
  ADMIN_PRODUCT_LIST: 'admin-product-list',
  ADMIN_CATEGORY_LIST: 'admin-category-list',
  ADMIN_MACHINE_LIST: 'admin-machine-list',
  ADMIN_ROOM_LIST: 'admin-room-list',
  ADMIN_FRANCHISE_LIST: 'admin-franchise-list',
  ADMIN_PAYMENT_OPTION_LIST: 'admin-payment-option-list',
  ADMIN_GROUP_LIST: 'admin-group-list',
  ADMIN_GROUP_SHOW: 'admin-group-show',
  ADMIN_USER_LIST: 'admin-user-list',
  PEOPLE_LIST: 'people-list',
  PEOPLE_SHOW: 'people-show',
  MEDICALCONDITION_LIST: 'medicalConditions-list',
  MEDICALCONDITION_SHOW: 'medicalConditions-show',
  GROUP_LIST: 'group-list',
  GROUP_SHOW: 'group-show',
  SALE_SHOW: 'sale-list',
  BILLING_LIST: 'billing-list',
  BILLING_SHOW: 'billing-show',
  PAYMENT_SHOW: 'payment-show',
  BUDGET_SHOW: 'budget-show',
  ROOM_LIST: 'room-list',
  ROOM_SHOW: 'room-show',
  BUDGET_LIST: 'budget-list',
  CLIENT_TEMPORARILY_LIST: 'client-temporarily-list',
  CHANGE_CART: 'change_cart',
  TRANSFER_CART: 'transfer-cart',
}
export {QUERIES}
